export default {
    'not completed': 'Non complété',
    'in progress': 'En cours',
    done: 'Complété'
};
